import useSWR from 'swr';
// logic
import getWorkingAreas from 'modules/emergencies/api/getWorkingAreas';

// returns working areas with loading/reloading state
export const useWorkingAreas = () => {
  const { data: workingAreas, error: workingAreasError } = useSWR(
    `price-negotiation/working-areas?page_size=0`,
    getWorkingAreas,
    {
      errorRetryCount: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const isLoadingWorkingAreas = typeof workingAreas === 'undefined' && !workingAreasError;
  let workingAreasOptions = [];
  if (workingAreas) {
    workingAreasOptions = (workingAreas?.results || []).map((workingArea) => {
      let name = workingArea.slug;
      try {
        name = workingArea.full_name;
        if (!name || name.trim() === '') name = workingArea.slug;
      } catch (e) {
        name = workingArea.slug;
      }
      return {
        value: workingArea.id,
        label: name,
        display: name,
        search: name,
      };
    });
  }

  return {
    workingAreas,
    workingAreasOptions,
    isLoadingWorkingAreas,
    workingAreasError,
  };
};
